<template>
	<div class="engine-address-search">
		<div class="row">
			<div class="col" style="display: flex; flex-direcion: row;">
				<input class="form-control" v-model="addressSearchPhrase" placeholder="Číslo Popisné" v-on:keyup.enter="fetchAddressNames"/>
				<div class="address-input-hide ml-1" @click="hideAddress"> {{ addressHide ? '▼' : '◄' }} </div>
			</div>
		</div>

		<div class="row mt-2" >
			<div class="col" style="display: flex; justify-content: space-between;">
				<button class="btn sedej" @click="fetchAddressNames"> Hledej </button>
				<button v-if="! addressAdding" @click="addressAddingStart" class="btn sedej"> + </button>
				<div v-else class="address-adding-buttons"> 
					<button @click="addressAddingStop" class="btn sedej"> X </button>
				</div>
				<button v-if="addressReversed" class="btn sedej" @click="addressReverse"> Sestupně </button>
				<button v-else class="btn sedej" @click="addressReverse"> Vzestupně </button>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col">
				<span class="selected-address"> Vybráno: <div v-if="selectedAddress" > č.p.: {{ selectedAddress.number_popisne }} ({{ selectedAddress.city_part_name }}) </div> </span>
			</div>
		</div>
		
		<div class="row">
			<div class="col text-left">
				<span v-if="! streetAdditionEditing" class="selected-poznamka"> Poznámka(ulice): {{ poznamka && poznamka.length && poznamka[0].txt !== '' ? poznamka[0].txt : 'neni' }} <button class="btn btn-sm sedej" @click="toggleStreetAdditionEdit"> edit </button> </span>
				<div v-else class="input-group" > 
					<input class="form-control" v-model="newPoznamka" />
					<div class="input-group-append">
						<button class="btn btn-success btn-outline-success" style="color: black;" type="button" id="button-addon2" @click="streetAdditionEditSave(cityName, streetName)" > ✓ </button>
						<button class="btn btn-danger btn-outline-danger" style="color: black;" type="button" id="button-addon2" @click="toggleStreetAdditionEdit"> X </button>
					</div>
				</div> 
			</div>
		</div>

		<div class="row" v-show="addressHide" v-if="! searching">
			<div class="col">
				<ul class="list-group my-list">
					<li class="list-group-item cursor-pointer text-left" 
						:class="{ active: isActive(name.number_popisne) }"
						v-for="(name) of addressNames" :key="name.adresni_misto"
						@click="addressSelect(name)"
						> 
							{{ name.number_popisne }}/{{ name.number_orientacni }} {{ name.sign_orientacni }} ({{ name.city_part_name }}) <button v-on:click.stop="stop" class="delete-address" v-if="name.created" @click="deleteAddress(name.index)"> X </button>
						</li>
				</ul>
			</div>
		</div>

		<div v-show="addressHide" v-else :class="{ addresslistsearching: (! addressAdding), addresslistaddingsearching: addressAdding }">
			<circle-spin :loading="searching"></circle-spin>
		</div>
	</div>
</template>

<script>
import modal from '@/components/modal.vue';
import AdditionsService from '@/services/AdditionsService'

export default {
	name: 'addressSearch',
	components: {
        modal,
    },
	props: {
		cityName: null,
		streetName: null,
	},

	data () {
		return {
			addressSearchPhrase: '',
			searching: false,
			selectedAddress: null,
			addressNames: [],
			addressReversed: false,
			addressAdding: false,
			existsSearching: false,
			addressHide: true,
			poznamka: null,
			streetAdditionEditing: false,
			newPoznamka: '',
			addressAddingCityPart: '',
			isModalVisible: false,
			addressAddingName: '0',
			addressAddingNameTwo: '0',
			addressAddingNameThree: null,
			popNeboEv: 'č.p.',
		}
	},

	async created () {
		this.searching = true
		const hold = await AdditionsService.fetchAddressNames('', this.$props.cityName, this.$props.streetName)
		this.addressNames = hold.data.names
		this.poznamka = hold.data.pozn
		this.searching = false
	},

	methods: {
		showModal(text) {
            this.isModalVisible = true;
		},
		
        closeModal() {
			this.isModalVisible = false;
			this.addressAddingStop()
		},
		
		async streetAdditionEditSave (cityName, streetName) {
			const hold = await AdditionsService.saveUlicePoznamka(this.newPoznamka, cityName, streetName)
			if (hold.data) {
				this.poznamka = []
				this.poznamka.push({ txt: this.newPoznamka })
				this.streetAdditionEditing = false
			}
		},

		toggleStreetAdditionEdit () {
			if (! this.poznamka || ! this.poznamka.length) {
				this.newPoznamka = ''
			} else {
				this.newPoznamka = this.poznamka[0].txt
			}

			this.streetAdditionEditing = ! this.streetAdditionEditing
		},

		hideAddress () {
			this.addressHide = ! this.addressHide
		},

		async addressDraftNameDone () {
			this.existsSearching = true
			const hold = await AdditionsService.addressNameExists(this.streetName, this.$props.cityName, this.addressAddingName, this.addressAddingNameTwo, this.addressAddingNameThree, this.popNeboEv, this.addressAddingCityPart)
			this.existsSearching = false

			if (hold.data) {
				this.addressNames.unshift(hold.data[0])
				this.addressAdding = false
				this.addressAddingName = 0
				this.addressAddingNameTwo = 0
				this.addressAddingNameThree = 0
				this.addressAddingCityPart = ''
			}
			this.closeModal()
		},

		addressAddingStop() {
			this.addressAdding = false
			this.addressAddingName = ''
			this.addressAddingCityPart = ''
		},

		addressAddingStart () {
			this.addressAdding = true
			this.selectedAddress = null
			this.$emit('addressAddingStart')
			this.showModal('a')
		},

		addressReverse () {
			this.addressReversed = ! this.addressReversed

			this.addressNames = this.addressNames.reverse()
		},

		async fetchAddressNames () {
			this.streetAdditionEditing = false
			const addressSearchPhrase = this.addressSearchPhrase
			this.searching = true
			this.poznamka = null
			this.selectedAdderss = null

			const hold = await AdditionsService.fetchAddressNames(addressSearchPhrase, this.$props.cityName, this.$props.streetName)

			this.addressNames = hold.data.names
			this.poznamka = hold.data.pozn
			this.searching = false
		},

		addressSelect (a) {
			this.selectedAddress = a
			this.$emit('addressSelect', a)
		},

		isActive (name) {
			if (! this.selectedAddress) {
				return false
			}
			if (name === this.selectedAddress.number_popisne) {
				return true
			}
			return false
		},
		
		async setAddressNames (cityName, streetName) {
			this.streetAdditionEditing = false
			this.selectedAdderss = null
			this.addressAddingStop()
			this.addressSearchPhrase = ''
			this.poznamka = null
			this.searching = true
			const hold = await AdditionsService.fetchAddressNames(this.addressSearchPhrase, cityName, streetName)
			this.addressNames = hold.data.names
			this.poznamka = hold.data.pozn
			this.searching = false
		},

		async deleteAddress (index) {
			const hold = await AdditionsService.deleteAddressName(index)
			if (hold.data) {
				await this.fetchAddressNames()
			}
		},

		stop () {
			// console.log('stopping propagation')
		}
	},
}
// TODO stylus css omg

</script>

<style scoped>
.sedej {
	background-color: #cccccc;
}
.flex-row {
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.flex-row-item {
	width: 49%;
	padding-top: 10px;
	display: flex;
	flex-direction: column;
}

.flex-row-item-input {
	display: flex;
	flex-direction: row;
	justify-content: left;
	margin-top: 10px;
	padding-left: 10px;
	line-height: 40px;
}
.just-flex {
	display: flex;
	flex-direction: row;
	justify-content: center;
}
.flex-row-item-row {
	height: 40px;
	text-align: right;
	line-height: 40px;
	padding-right: 10px;
	margin-top: 10px;
}

.my-list {
	max-height: 300px;
	min-height: 300px;
	overflow-y: scroll;
	background-color: white;
	padding: 0px;
	cursor: pointer;

	/* margin-top: 30px; */
}


.starting {
	width: 200px;
	background-color: red;
}
.engine-address-search {
	display: flex;
	flex-direction: column;
	width: 250px;
	padding: 10px;
	font-family: 'Roboto', sans-serif;
}

.address-input {
	width: 100%;
	height: 40px;
	padding-left: 5px;
	
}

.address-search-buttons {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.address-search {
	height: 30px;
}

.address-add {
	height: 30px;
	width: 30px;
}

.address-adding-buttons {
	width: 70px;
}

/* .address-add-save {
	height: 30px;
	width: 30px;
} */

.address-add-remove {
	height: 30px;
	width: 30px;
}

.addresslist {
	background-color: white;
	width: 100%;
	height: 300px;
	margin-top: 10px;
	overflow-y: scroll;
}

.addresslistadding {
	background-color: white;
	width: 100%;
	height: 200px;
	overflow-y: scroll;
}

.address-name-adding {
	height: 40px;
	margin-top: 30px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.address-name-adding-input {
	height: 40px;
	width: 100px;
	padding-left: 10px;
}

.address-znak-adding-input {
	height: 40px;
	width: 30px;
	padding-left: 10px;

}

.address-city-part-adding-input {
	height: 40px;
	width: 100%;
}

.address-name-adding-button {
	height: 40px;
	width: 19%;
}

.address-reverse {
	height: 30px;
}

.address-list {
	background-color: white;
	width: 100%;
	height: 300px;
	margin-top: 10px;
	overflow-y: scroll;
}

/* .address-list-searching {
	background-color: rgba(255, 0, 0, 0.315);
	width: 100%;
	height: 300px;
	margin-top: 10px;
} */

.addresslistsearching {
	background-color: #CCE6FF;
	width: 100%;
	height: 300px;
	margin-top: 10px;
}

/* .addresslistsearchingadding {
	background-color: rgba(255, 0, 0, 0.315);
	width: 100%;
	height: 260px;
	margin-top: 10px;
} */

.address-list-item {
	height: 40px;
	line-height: 40px;
	font-size: 18px;
	border-bottom: 1px solid gray;
	background-color: #CCE6FF;
	text-align: left;
	padding-left: 10px;
	color: rgb(73, 73, 73);
	white-space: nowrap; 
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
}

.active {
	background-color: #9CCFFF;
}

.address-input-together {
	display: flex;
	flex-direction: row;
}
.address-input-hide {
	display: none;
}

.selected-address {
	text-align: left;
	display: flex;
	flex-direction: row;
	justify-content: left;
}

.selected-poznamka {
	text-align: left;
}

.delete-address {
	background-color: red;
}

.modal-butt-yes {
    height: 30px;
    width: 120px;
    border: none;
    background-color: #4CA5F9;
    cursor: pointer;

}

.modal-butt-no {
    height: 30px;
    width: 120px;
    border: none;
    background-color: red;
    cursor: pointer;
}


@media (max-width: 1000px) {
	.engine-address-search {
		display: flex;
		flex-direction: column;
		width: 90%;
		padding: 10px;
		font-family: 'Roboto', sans-serif;

	}

	.address-input-hide {
		display: block;
		width: 40px;
		height: 38px;
		background-color: #cccccc;
		line-height: 40px;
		font-size: 24px;
		cursor: pointer;
		border-radius: 5px;
	}

}
</style>



// WEBPACK FOOTER //
// src/components/engine/addressSearch.vue